import React from 'react';

import styles from './ForgotPageIndex.module.scss';

export type ForgotPageIndexItem = {
  id: string;
  label: string;
};

type Props = {
  title: string;
  items: ForgotPageIndexItem[];
};

const ForgotPageIndex: React.FC<Props> = ({ title, items }) => (
  <div className={styles.pageIndex}>
    <div className={styles.title}>{title}</div>
    <ul className={styles.list}>
      {items.map((item) => (
        <li key={item.id}>
          <a href={`#${item.id}`} className={styles.link}>
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default ForgotPageIndex;
